var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('badge',{staticClass:"status-badge",attrs:{"type":_vm.badgeType}},[_vm._t("default",function(){return [_vm._v("\n    "+_vm._s(_vm.status)+"\n  ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }